export const withExternalLink = richText => {
  const linkClass = `class="link-new-tab"`
  const targetAttr = `target="_blank"`

  const isExternal = richText?.includes(linkClass)
  const richTextWithExternalLink = isExternal && richText.replace(linkClass, targetAttr)

  return richTextWithExternalLink || richText
}
